import { section } from "@/neon";
import { animateCollectionListGrid } from "@/lib/animation";

section("collection-list-grid", {
  onLoad() {
    this.animateCollectionListGrid = animateCollectionListGrid(this.container);
  },

  onUnload() {
    this.animateCollectionListGrid?.destroy();
  },
});
